var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"digital-twin-page"},[_c('Nav'),_c('PageHero',{attrs:{"heroSrc":_vm.heroSrc,"title":_vm.title,"sub":_vm.sub}}),_c('SubPageContent',{attrs:{"sections":_vm.sections,"pageName":'xr'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }